module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.39b2c30.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.woff2
// module id = 311
// module chunks = 1